// @flow
import {identity} from 'ramda';
import {createActions, handleActions, type ReduxReducer} from 'redux-actions';

import type {ActionType} from 'constants/flow/flowTypes';

import type {PossibleActionTypesType} from './previousProductIdentifierType';

export const initialState: number = 0;

export const {
    previousProductIdentifier: {set, reset},
} = createActions({
    PREVIOUS_PRODUCT_IDENTIFIER: {
        /**
         * Sets given value
         */
        SET: identity,

        /**
         * Resets initial value
         */
        RESET: () => {},
    },
});

/**
 * Reducer
 * @type {ReduxReducer<number, PossibleActionTypesType>}
 */
export const previousProductIdentifier: ReduxReducer<
    number,
    PossibleActionTypesType,
> = handleActions(
    {
        /**
         * Handles set action
         * @param {number} state - previous state value
         * @param {ActionType<number>} action - dispatched action
         * @returns {number} new state value
         */
        [set]: (state: number, {payload}: ActionType<number>): number => payload,

        /**
         * Handles reset action
         * @returns {number} new state value
         */
        [reset]: (): number => initialState,
    },
    0,
);
